import { FileTextIcon, ZapIcon, BotIcon, LaptopIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% Digital PDF & Accès Mobile'
}, {
  icon: ZapIcon,
  label: 'Téléchargement Instantané'
}, {
  icon: BotIcon,
  label: 'Compatible avec ChatGPT, Claude, Gemini & DeepSeek'
}, {
  icon: LaptopIcon,
  label: 'Optimisé pour Ordinateur & Tablette'
}];
export const stats = [{
  value: '500+',
  label: 'Avocats Satisfaits'
}, {
  value: '6+4',
  label: 'Volumes + Bonus'
}, {
  value: '99%',
  label: 'Taux de Réussite'
}, {
  value: '4.9/5',
  label: '⭐ Note Globale'
}];
